class GetPostError extends Error {
  constructor(errorCode) {
    super();
    this.message = errorCode ? `errors.getPost.${errorCode}` : 'errors.getPost.general';
  }
}

export { GetPostError };
